import React from 'react';
import { render } from 'react-dom';
import PdfCartApplication from './pdf-cart/main/pdfCart.application';
import PresentationCartApplication from './presentation-cart/main/presentationCart.application';
import BrochurePDFCartApplication from './brochure-cart/main/pdfCart.application';
import ReturnScenariosCartApplication from './return-scenarios-cart/main/returnScenarios.application';

// Helper function to safely render React components
function safeRender(component: React.ReactElement, containerId: string) {
    const container = document.getElementById(containerId);
    if (container) {
        render(component, container);
    } else {
        console.warn(`React container '${containerId}' not found. Component not rendered.`);
    }
}

// Render all cart applications with error handling
safeRender(<PdfCartApplication />, 'pdf-cart-root');
safeRender(<PresentationCartApplication />, 'presentation-cart-root');
safeRender(<BrochurePDFCartApplication />, 'brochure-pdf-cart-root');
safeRender(<ReturnScenariosCartApplication />, 'return-scenarios-cart-root');
